import { render, staticRenderFns } from "./Account3CRUD.vue?vue&type=template&id=0d597dc9"
import script from "./Account3CRUD.vue?vue&type=script&lang=js"
export * from "./Account3CRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports